import React from 'react';
import { AlertTriangle, Calendar, Users, X } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

const LeaveSchoolModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  schoolName, 
  isLoading = false 
}) => {
  if (!isOpen) return null;
    const { t, locale } = useLanguage();

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md mx-4 transform transition-all">
        {/* Header */}
        <div className="relative p-6 pb-4">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 w-8 h-8 bg-gray-100 hover:bg-gray-200 rounded-full flex items-center justify-center transition-colors"
            disabled={isLoading}
          >
            <X className="h-4 w-4 text-gray-500" />
          </button>
          
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center">
              <AlertTriangle className="h-6 w-6 text-red-600" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900">
                {t('invitations.leaveSchool')}
              </h3>
              <p className="text-sm text-gray-500">
               {t('invitations.noBackPossible')}
              </p>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="px-6 pb-6">
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6">
            <p className="text-sm text-amber-800 mb-3">
              {t('invitations.leaveInformations')}{' '}
              <span className="font-semibold">{schoolName}</span>
            </p>
            
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <Calendar className="h-5 w-5 text-amber-600 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-sm font-medium text-amber-900">
                    {t('invitations.sharingSchedule')}
                  </p>
                  <p className="text-xs text-amber-700">
                    {t('invitations.youLooseSharingSchedule')}
                  </p>
                </div>
              </div>
              
              <div className="flex items-start gap-3">
                <Users className="h-5 w-5 text-amber-600 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-sm font-medium text-amber-900">
                     {t('invitations.studentList')}
                  </p>
                  <p className="text-xs text-amber-700">
                    {t('invitations.youLooseSharingSchedule')}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <p className="text-sm text-gray-600 mb-6">
            {t('invitations.forRejoinSchool')}.
          </p>

          {/* Actions */}
          <div className="flex flex-col gap-3">
            <button
              onClick={onConfirm}
              disabled={isLoading}
              className="w-full bg-red-600 hover:bg-red-700 disabled:bg-red-400 text-white font-medium py-3 px-4 rounded-lg transition-colors flex items-center justify-center gap-2"
            >
              {isLoading ? (
                <>
                  <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                   {t('invitations.deconnectSchool')}...
                </>
              ) : (
                t('invitations.deconnectSchool')
              )}
            </button>
            
            <button
              onClick={onClose}
              disabled={isLoading}
              className="w-full bg-gray-100 hover:bg-gray-200 disabled:bg-gray-50 text-gray-700 font-medium py-3 px-4 rounded-lg transition-colors"
            >
              {t('common.cancel')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeaveSchoolModal;